const HOUR_MS = 60 * 60 * 1000;
const MINUTE_MS = 60 * 1000;
const TZ_SUFFIX_RE = /(Z|[+-]\d{2}:?\d{2})$/;

export function parseCostBucketTime(timestamp) {
  if (timestamp instanceof Date) return timestamp;
  if (typeof timestamp === 'string' && !TZ_SUFFIX_RE.test(timestamp)) {
    return new Date(`${timestamp}Z`);
  }
  return new Date(timestamp);
}

export function costDrilldownBucketMs(timeWindow) {
  switch (timeWindow) {
    case '1h':
    case '6h':
    case '12h':
    case '24h':
    case '24hours':
      return MINUTE_MS;
    case '2d':
    case '7d':
    case '7days':
      return HOUR_MS;
    default:
      return 24 * HOUR_MS;
  }
}

export function formatDrilldownTime(date) {
  return date.toISOString().slice(0, 19);
}

export function buildCostDrilldownWindow(timestamp, timeWindow) {
  const start = parseCostBucketTime(timestamp);
  const end = new Date(start.getTime() + costDrilldownBucketMs(timeWindow));
  return {
    start_time: formatDrilldownTime(start),
    end_time: formatDrilldownTime(end),
  };
}
